export const FIFTEEN_DAYS_IN_HOURS = 360;

export const INFO_BOX = "info@melp.com";
